<template>
  <div class="login" >
    <img :src="activity" alt="img" class="backgroundImg">
    <div class="form">
      <!-- 表单 -->
      <div>
        <van-field v-model="name" clearable label="询价人姓名：" placeholder="请输入姓名" />
        <van-radio-group v-model="radio">
          <label for class="label">询价人性别：</label>
          <van-radio name="1" checked-color="#8032BF">
            先生
            <img
              slot="icon"
              slot-scope="props"
              :src="props.checked ? activeIcon : inactiveIcon"
              class="img"
              alt=""
            />
          </van-radio>
          <van-radio name="2" checked-color="#8032BF" style="margin-left:10px">
            女士
            <img
              slot="icon"
              slot-scope="props"
              :src="props.checked ? activeIcon : inactiveIcon"
              class="img"
              alt=""
            />
          </van-radio>
        </van-radio-group>
        <van-field v-model="phone" clearable label="询价人电话：" placeholder="请输入电话号码" class="borderBottom" />
      </div>
      <!-- 服务专员 -->
      <div>
        <div class="service">
          <img :src="toux" class="image" alt="" />
          <div class="news">
            <p>服务专员：李健龙</p>
            <p>联系方式：15240687373</p>
          </div>
        </div>
        <div class="btn" @click="submit()">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import api from "@/api/api.js";
export default {
  data() {
    return {
      activity: api.imgAllUrl + "/huodong_20191227.png",
      toux: api.imgAllUrl + "/tou_20191227.png",
      activeIcon: api.imgAllUrl + "/xuanz_20191227.png",
      inactiveIcon: api.imgAllUrl + "/xuanc_20191227.png",
      phone: "",
      name: "",
      radio: "1"
    };
  },
  created() {
    document.title = "电信员工车服务方案";
  },
  mounted() {},
  methods: {
    // 提交
    submit() {
      if (!this.name) {
        Toast("请输入姓名");
        return;
      }
      if (!this.phone) {
        Toast("请输入电话号码");
        return;
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        Toast("请输入正确电话号码");
        return false;
      }
      let href = window.location.href;
      let object = {};
      href
        .substring(href.indexOf("?") + 1)
        .split("#")[0]
        .split("&")
        .forEach(value => {
          let values = value.split("=");
          object[values[0]] = values[1];
        });
      let ParticipantsInsertReqDto = {
        gender: this.radio,
        participantsName: this.name,
        participantsType: 1,
        phoneNumber: this.phone,
        source: 'OfflinePromotion'
      };
      this.$http
        .post(api.carActivity+object.activityId+'/participants/', ParticipantsInsertReqDto)
        .then(res => {
          if (res.data.rtnCode == "9920") {
            Toast(res.data.rtnMsg);
            return;
          }
          if (res.data.rtnCode == "9921") {
            Toast(res.data.rtnMsg);
            return;
          }
          if (res.data.rtnCode == "0000") {
            Toast("提交成功");
          }
        })
        .catch(err => {
          Toast("提交失败");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./Login.scss";
</style>





// WEBPACK FOOTER //
// src/pages/Login/Login.vue